<template>
  <div class="chart-container">
    <div
      @touchstart="touchStart($event)"
      @touchmove="touchMove($event)"
      @touchend="touchEnd($event)"
      id="chart">
    </div>
    <div class="title">
      <span class="heng red-bg"></span>
      <span class="tip-title">融资余额:</span>
      <span class="red-text" style="margin-right:.2rem">{{ subTitle[0].value }}</span>
      <span class="heng green-bg"></span>
      <span class="tip-title">融券余额: </span>
      <span class="green-text">{{ subTitle[1].value }}</span>
    </div>
  </div>
</template>

<script>
  import {request} from '@/api/request';
  import Utils from '@/utils/formatUnit';
  import echarts from 'echarts';

  export default {
    name: 'QzqrChart',
    data() {
      return {
        canScroll: true,
        subData: [],
        subTitle: [
            {
              title: '融资余额',
              value: '-',
              type: '',
              unit: '亿'
            },
            {
              title: '融券余额',
              value: '-',
              type: '',
              unit: '亿'
            }
          ]
      }
    },
    props: ['innerCode'],
    watch: {
      canScroll(val) {
        if(val) {
          document.querySelector('#app').removeEventListener('touchmove', this.forbiddenScroll, false)
          //this.handleTip({show: val})
        } else {
          document.querySelector('#app').addEventListener('touchmove', this.forbiddenScroll, false)
        }
      }
    },
    methods: {
      renderChart() {
        let vm = this
        let option = {
          grid: {
            left: 30,
            right: 35,
            bottom: 25,
            top: 10,
            show: false,
            borderColor: '#cccccc'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              snap: false
            },
            formatter () {
              return ''
            }
          },
          axisPointer: {
            lineStyle: {
              type: 'dashed'
            }
          },
          xAxis: {
            show: true,
            type: 'category',
            nameTextStyle: {
              color: '#666',
            },
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                width: 1,
                color: '#B4B4B4'
              }
            },
            axisPointer: {
              label: {
                formatter (val) {
                  vm.handleTip(val.seriesData[0].dataIndex)
                  return val.value
                }
              }
            },
            axisLabel: {
              show: true,
              // interval: function (index, value) {
              //   const multiple = 120
              //   if(index % multiple === 0) {
              //     return true
              //   }
              // }
            },
            lineStyle: {
              width: 1
            },
            data: vm.subData[2]
          },
          yAxis: [{
            show: true,
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                width: 1,
                // color: '#b4b4b4'
                color: '#258D01'
              }
            },
            axisLabel: {
              formatter: function(value) {
                return value/100000000
              }
            },
            type: 'value'
          }, {
            show: true,
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                width: 1,
                // color: '#B4B4B4'
                color: '#D4332F'
              }
            },
            axisLabel: {
              formatter: function(value) {
                return value/100000000
              }
            },
            type: 'value'
          }],
          series: [
            {
              data: vm.subData[0],
              name: '融资',
              yAxisIndex: 1,
              symbol: 'none',
              type: 'line',
              lineStyle: {
                color: '#D4332F',
                width: 1
              }
            },
            {
              data: vm.subData[1],
              name: '融券',
              yAxisIndex: 0,
              symbol: 'none',
              type: 'line',
              lineStyle: {
                color: '#258D01',
                width: 1
              }
            }
          ]
        }
        this.chart.setOption(option)
        this.chart.resize()
      },
      forbiddenScroll(e) {
        e.preventDefault()
      },

      touchStart(e) {
        this.canScroll = false
      },
      touchMove(e) {
        if(this.canScroll) return this.touchEnd()
      },
      touchEnd() {
        this.canScroll = true
      },
      getSubTitleType(arr, index) {
        if(index === 0
          || arr[index] - arr[index - 1] === 0) return ''
        if(arr[index] - arr[index - 1] > 0) return '↑'
        if(arr[index] - arr[index - 1] < 0) return '↓'
      },
      handleTip(index) {
        let financeValue = this.subData[0][index];
        let securityValue = this.subData[1][index];
        this.subTitle[0].value = Utils.formatUnit(financeValue, '亿')
        this.subTitle[1].value = Utils.formatUnit(securityValue, '亿')
        this.subTitle[0].type = this.getSubTitleType(financeValue)
        this.subTitle[1].type = this.getSubTitleType(securityValue)
      },
      async getChartsData() {
        const res = await request.get({
            url: request.apis.quote.queryIndividualStockFiSeByCode,
            params: {InnerCode: this.innerCode}
        })
        let series0 = []
        let series1 = []
        let time = []
        res.map(item => {
          series0.push(item.FinanceValue)
          series1.push(item.SecurityValue)
          time.push(item.Tradingday.substring(0, 10).replace(/-/g,'/'))
        })
        this.subData = [series0, series1, time]
        this.renderChart()
        this.handleTip(res.length-1)
      },
    },
    async mounted() {
      setTimeout(()=>{
        this.chart = echarts.init(document.getElementById('chart'))
        this.getChartsData()
      }, 300)
    }
  }
</script>

<style lang="stylus" src="./index.styl" scoped></style>